export default __webpack_public_path__ + "static/media/6-parceiros.4faac70a.svg";